<template>
    <div class="scrollable-page-con" ref="scrollablePageCon">
        <div class="fixed-portion-con">
            <slot name="header"></slot>
        </div>
        <div class="scrollable-portion-con" ref="scrollablePortionCon" :style="style">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name : 'ScrollablePageLayout',
    props : {
        noTopOffset : {
            type : Boolean,
            required : false,
            default : false,
        },
    },
    data () {
        return {
            style : {
                height : '0px',
            },
        };
    },
    mounted () {
        this.resize();
        window.addEventListener('resize', this.resize, { passive : true });
    },
    destroyed () {
        window.removeEventListener('resize', this.resize);
    },
    methods : {
        resize () {
            let height = this.$refs.scrollablePageCon.getBoundingClientRect().height
            let portionTop = 0;
            if(!this.noTopOffset){
                portionTop = this.$refs.scrollablePortionCon.getBoundingClientRect().top;
                height -= portionTop - this.$refs.scrollablePageCon.getBoundingClientRect().top;
            }
            if(height <= 0){
                let iter = 0;
                let parent = this.$refs.scrollablePageCon.parentElement;
                while(height <= 0 && iter < 10 && parent) {
                    height = parent.getBoundingClientRect().height;
                    parent = parent.parentElement;
                    iter++;
                }
                height -= portionTop;
                //height = this.$refs.scrollablePageCon.parentElement.getBoundingClientRect().height - 20;
            }
            this.style.height = height > 0 ? height + 'px' : '100%';
        },
    }

}
</script>

<style scoped>
    .scrollable-page-con {
        position:relative;
        padding:15px 15px 0 15px;
    }
    .scrollable-portion-con {
        overflow-y:auto;
        position:relative;
    }
</style>
